// extracted by mini-css-extract-plugin
module.exports = {"card":"payment-funnel_card__ZK_xP","section":"payment-funnel_section__5KrWX","anchor":"payment-funnel_anchor__n7y3r"};